import axios from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import {
    GET_ADMIN_SEARCH_LIST_FAILURE,
    GET_ADMIN_SEARCH_LIST_REQUEST,
    GET_ADMIN_SEARCH_LIST_SUCCESS,
    ADD_ADMIN_LOCATION_FAILURE,
    ADD_ADMIN_LOCATION_REQUEST,
    ADD_ADMIN_LOCATION_SUCCESS,
    GET_INVITED_ADMIN_FAILURE,
    GET_INVITED_ADMIN_REQUEST,
    GET_INVITED_ADMIN_SUCCESS,
    REMOVE_INVITED_ADMIN_FAILURE,
    REMOVE_INVITED_ADMIN_REQUEST,
    REMOVE_INVITED_ADMIN_SUCCESS,
    CLEAR_MESSAGES,
} from '../constants/invitedLocations.constant';

const getAdminSearchListRequest = () => {
    return {
        type: GET_ADMIN_SEARCH_LIST_REQUEST,
    };
};

const getAdminSearchListSuccess = (adminSearchData: AnyIfEmpty<object>) => {
    return {
        type: GET_ADMIN_SEARCH_LIST_SUCCESS,
        payload: adminSearchData,
    };
};

const getAdminSearchListFailure = (adminSearchError: string) => {
    return {
        type: GET_ADMIN_SEARCH_LIST_FAILURE,
        payload: adminSearchError,
    };
};

const addAdminLocationRequest = () => {
    return {
        type: ADD_ADMIN_LOCATION_REQUEST,
    };
};

const addAdminLocationSuccess = (addAdminLocationData: AnyIfEmpty<object>) => {
    return {
        type: ADD_ADMIN_LOCATION_SUCCESS,
        payload: addAdminLocationData,
    };
};

const addAdminLocationFailure = (addAdminLocationError: string) => {
    return {
        type: ADD_ADMIN_LOCATION_FAILURE,
        payload: addAdminLocationError,
    };
};

const getInvitedAdminRequest = () => {
    return {
        type: GET_INVITED_ADMIN_REQUEST,
    };
};

const getInvitedAdminSuccess = (invitedAdminData: AnyIfEmpty<object>) => {
    return {
        type: GET_INVITED_ADMIN_SUCCESS,
        payload: invitedAdminData,
    };
};

const getInvitedAdminFailure = (errorMsg: string) => {
    return {
        type: GET_INVITED_ADMIN_FAILURE,
        payload: errorMsg,
    };
};

const removeInvitedAdminRequest = () => {
    return {
        type: REMOVE_INVITED_ADMIN_REQUEST,
    };
};

const removeInvitedAdminSuccess = (data: AnyIfEmpty<object>) => {
    return {
        type: REMOVE_INVITED_ADMIN_SUCCESS,
        payload: data,
    };
};

const removeInvitedAdminFailure = (errorMsg: string) => {
    return {
        type: REMOVE_INVITED_ADMIN_FAILURE,
        payload: errorMsg,
    };
};



const clearAllMessages = () => {
    return {
        type: CLEAR_MESSAGES,
    };
};

export const clearExistingMessages = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch(clearAllMessages());
    };
};

export const getAdminSearchList = (locationId: string | undefined, searchText?: string | undefined) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getAdminSearchListRequest());
        await axios
            .get(`/admin/search/${locationId}`, {
                params: {
                    searchText,
                },
            })
            .then((response) => dispatch(getAdminSearchListSuccess(response.data)))
            .catch((error) => dispatch(getAdminSearchListFailure(error.message)));
    };
};

export const addAdminLocation = (addAdminLocationObj: AnyIfEmpty<object>) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(addAdminLocationRequest());
        await axios
            .post('/admin/locations/location-invited-histroy', addAdminLocationObj)
            .then((response) => {
                dispatch(addAdminLocationSuccess(response.data));
                dispatch(getAdminSearchList(addAdminLocationObj.locationId));
            })
            .catch((err) => dispatch(addAdminLocationFailure(err.message)));
    };
};



export const getInvitedAdminList = (locationId: string | undefined, AdminId: string | undefined) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getInvitedAdminRequest());
        await axios
            .get(`/admin/locations/invited-user-list/${locationId}`, {
                params: {
                    AdminId,
                },
            })
            .then((response) => {
                dispatch(getInvitedAdminSuccess(response.data.data))
            }
            )
            .catch((err) => dispatch(getInvitedAdminFailure(err.message)));
    };
};

export const removeInvitedAdminList = (obj: AnyIfEmpty<object>) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(removeInvitedAdminRequest());
        await axios
            .post(`admin/locations/delete-invited-user`, obj)
            .then((response) => {
                dispatch(getAdminSearchList(obj.locationId));
                dispatch(removeInvitedAdminSuccess(response.data));
            })
            .catch((err) => dispatch(removeInvitedAdminFailure(err.message)));
    };
};
